(()=>{
const init=root=>{
if(root.dataset.ekcReady)return;
root.dataset.ekcReady='1';
const labels=JSON.parse(root.dataset.ekcLabels||'{}');
const currentUrl=new URL(location.href);
if(currentUrl.searchParams.getAll('filter.v.availability').join(',')!=='1'){
const next=new URL(location.href);
next.searchParams.set('filter.v.availability','1');
next.searchParams.delete('ek_stock');
next.searchParams.delete('page');
next.searchParams.delete('ek_pages');
location.replace(next.href);
return;
}
const keepStock=url=>{const next=new URL(url,location.href);next.searchParams.set('filter.v.availability','1');next.searchParams.delete('ek_stock');return next;};
root.querySelectorAll('a[href]').forEach(link=>{const next=new URL(link.href,location.href);if(next.origin===location.origin&&next.pathname.startsWith('/collections/'))link.href=keepStock(next).href;});
let cart=null;
const selectedId=card=>String(card.querySelector('.ekc-options select')?.value||card.dataset.ekcVariant||'');
const quantityFor=id=>(cart?.items||[]).filter(item=>String(item.variant_id||item.id)===String(id)).reduce((sum,item)=>sum+item.quantity,0);
const syncCards=()=>root.querySelectorAll('.ekc-card').forEach(card=>{
const id=selectedId(card),quantity=quantityFor(id),controls=card.querySelector('[data-ekc-cart-quantity]');
card.dataset.ekcVariant=id;
if(controls){controls.hidden=quantity===0;controls.querySelector('[data-ekc-quantity]').textContent=quantity;}
card.querySelectorAll('[data-ekc-add],[data-ekc-option-add]').forEach(button=>button.hidden=quantity>0);
});
document.addEventListener('ek:cart-updated',event=>{if(event.detail?.cart){cart=event.detail.cart;syncCards();}});
window.EkCart?.read().then(result=>{cart=result;syncCards();}).catch(()=>{});
root.addEventListener('change',event=>{
const input=event.target;
if(input.matches('[data-ekc-sort]'))input.form?.requestSubmit();
if(input.matches('.ekc-options select'))syncCards();
});
const filter=root.querySelector('.ekc-filters'),filterTrigger=root.querySelector('[data-ekc-filter-open]');
if(filter){filter.open=!matchMedia('(max-width:767px)').matches;filterTrigger?.setAttribute('aria-expanded',String(filter.open));}
filterTrigger?.addEventListener('click',()=>{if(filter)filter.open=!filter.open;});
filter?.addEventListener('toggle',()=>filterTrigger?.setAttribute('aria-expanded',String(filter.open)));
root.addEventListener('keydown',event=>{if(event.key==='Escape'&&filter&&matchMedia('(max-width:767px)').matches){filter.open=false;filterTrigger?.focus();}});
const backTop=root.querySelector('[data-ekc-back-top]');
const updateTop=()=>{if(backTop)backTop.hidden=scrollY<450;};
window.addEventListener('scroll',updateTop,{passive:true});
backTop?.addEventListener('click',()=>scrollTo({top:0,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'}));
updateTop();
const base=new URL(location.href);base.searchParams.delete('ek_pages');
const cacheKey='ekc:v2:'+base.pathname+base.search;
let loaded=1;
const save=()=>{try{const grid=root.querySelector('[data-ekc-grid]')?.cloneNode(true);grid?.querySelectorAll('[data-ekc-busy]').forEach(card=>{delete card.dataset.ekcBusy;card.querySelectorAll('[data-ekc-add],[data-ekc-option-add],[data-ekc-quantity-step],[data-ekc-buy]').forEach(button=>button.disabled=false);});sessionStorage.setItem(cacheKey,JSON.stringify({time:Date.now(),loaded,scroll:scrollY,grid:grid?.innerHTML,pagination:root.querySelector('[data-ekc-pagination]')?.outerHTML}));}catch{}};
try{
const cached=JSON.parse(sessionStorage.getItem(cacheKey)||'null');
if(cached&&Date.now()-cached.time<1800000&&cached.loaded>1&&Number(currentUrl.searchParams.get('ek_pages'))===cached.loaded){
root.querySelector('[data-ekc-grid]').innerHTML=cached.grid;
root.querySelector('[data-ekc-pagination]').outerHTML=cached.pagination;
loaded=cached.loaded;
requestAnimationFrame(()=>scrollTo({top:cached.scroll,behavior:'instant'}));
syncCards();
}
}catch{}
addEventListener('pagehide',save);
root.addEventListener('click',async event=>{
const ageLink=event.target.closest('[data-ek-age-filter] a,[data-ek-book-type-filter] a');
if(ageLink){
event.preventDefault();
const navigation=ageLink.closest('[data-ek-age-filter],[data-ek-book-type-filter]');
const tag=ageLink.closest('[data-ek-age-tag],[data-ek-book-type-tag]').getAttribute(navigation.hasAttribute('data-ek-book-type-filter')?'data-ek-book-type-tag':'data-ek-age-tag');
const known=new Set((navigation.dataset.ekBookTypeHandles||navigation.dataset.ekAgeHandles).split('|').filter(Boolean));
const next=keepStock(ageLink.href),parts=next.pathname.split('/');
const tags=(parts[3]||'').split('+').filter(Boolean).filter(value=>!known.has(decodeURIComponent(value)));
const active=(location.pathname.split('/')[3]||'').split('+').some(value=>decodeURIComponent(value)===tag);
if(tag&&!active)tags.push(tag);
parts[3]=tags.join('+');next.pathname=parts.slice(0,tags.length?4:3).join('/');next.search=location.search;
next.searchParams.delete('page');next.searchParams.delete('ek_pages');
location.assign(next.href);
return;
}
const action=event.target.closest('[data-ekc-add],[data-ekc-option-add],[data-ekc-quantity-step],[data-ekc-buy]');
if(action){
event.preventDefault();
const card=action.closest('.ekc-card');
if(action.disabled||card.dataset.ekcBusy)return;
const options=card.querySelector('.ekc-options');
if(action.hasAttribute('data-ekc-buy')&&options&&!options.open){options.open=true;options.querySelector('select')?.focus();return;}
const id=selectedId(card),status=card.querySelector('.ekc-status');
if(!id)return;
card.dataset.ekcBusy='1';
const actions=[...card.querySelectorAll('[data-ekc-add],[data-ekc-option-add],[data-ekc-quantity-step],[data-ekc-buy]')];
actions.forEach(button=>button.disabled=true);
status.textContent=labels.adding;
try{
if(!window.EkCart)throw Error(labels.error);
if(action.hasAttribute('data-ekc-quantity-step')){
cart=await window.EkCart.setVariantQuantity(id,Math.max(0,quantityFor(id)+Number(action.dataset.ekcQuantityStep)));
status.textContent='';
}else if(action.hasAttribute('data-ekc-buy')){
cart=await window.EkCart.read();
if(quantityFor(id)===0)cart=await window.EkCart.add(id,1);
status.textContent='';
window.EkCart.open();
}else{
cart=await window.EkCart.add(id,1);
status.textContent=labels.added;
}
syncCards();
save();
}catch(error){status.textContent=error.message||labels.error;}
finally{delete card.dataset.ekcBusy;actions.forEach(button=>button.disabled=false);}
return;
}
const more=event.target.closest('[data-ekc-more]');
if(!more)return;
event.preventDefault();loadMore(more,true);
});
let loading=false;
const completedPages=new Set();
const observer='IntersectionObserver' in window?new IntersectionObserver(entries=>{for(const entry of entries){if(entry.isIntersecting)loadMore(entry.target,false);}},{rootMargin:'0px 0px 480px 0px'}):null;
const watchNext=()=>{observer?.disconnect();const next=root.querySelector('[data-ekc-more]');if(next&&root.isConnected)observer?.observe(next);};
const loadMore=async(more,manual=false)=>{
if(loading||more.dataset.busy||!root.contains(more))return;
const url=keepStock(more.href);
if(completedPages.has(url.href)){observer?.unobserve(more);return;}
loading=true;more.dataset.busy='1';more.setAttribute('aria-disabled','true');more.textContent=labels.loading;
const currentGrid=root.querySelector('[data-ekc-grid]');currentGrid?.setAttribute('aria-busy','true');
const controller=new AbortController(),timeout=setTimeout(()=>controller.abort(),20000);
try{
const response=await fetch(url.href,{signal:controller.signal});if(!response.ok)throw Error();
const doc=new DOMParser().parseFromString(await response.text(),'text/html');
const grid=doc.querySelector('[data-ekc-grid]'),pagination=doc.querySelector('[data-ekc-pagination]');
if(!grid||!pagination)throw Error();
if(!root.isConnected)return;
const first=grid.firstElementChild;
currentGrid.append(...grid.children);
root.querySelector('[data-ekc-pagination]').replaceWith(pagination);
completedPages.add(url.href);loaded++;
const next=new URL(location.href);next.searchParams.set('ek_pages',String(loaded));history.replaceState(history.state,'',next.href);
syncCards();save();
if(manual&&first){first.tabIndex=-1;first.focus({preventScroll:true});}
watchNext();
}catch{observer?.unobserve(more);more.textContent=labels.retry;delete more.dataset.busy;more.removeAttribute('aria-disabled');}
finally{clearTimeout(timeout);loading=false;currentGrid?.removeAttribute('aria-busy');}
};
watchNext();
};
document.querySelectorAll('.ekc').forEach(init);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.ekc').forEach(init));
})();
